import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  NotificationManager,
} from '@alexpireddu/map-ui';
import { FC, useState, useCallback } from 'react';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { createCity } from '../../actions/cityActions';
import { useAction } from '../../hooks';
import NewCityModalForms from './NewCityModalForms';

export interface CreateCityModalProps {
  onClose: Function;
}

export interface CreateCityFormValues {
  name: string;
  regionId: string;
  provinceId: string;
  subscription: boolean;
}

const NewCityModal: FC<CreateCityModalProps> = ({ onClose }) => {
  const [isLoading, setLoading] = useState<boolean>(false);
  const useFormMethods = useForm<CreateCityFormValues>({
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: {
      name: undefined,
      provinceId: undefined,
      regionId: undefined,
      subscription: true, // Default to public subscription
    },
  });
  const { handleSubmit } = useFormMethods;

  const cityCreate = useAction(createCity);

  const handleOnSubmit: SubmitHandler<CreateCityFormValues> = useCallback(
    (data: CreateCityFormValues): void => {
      setLoading(true);
      cityCreate({
        name: data.name,
        province_id: data.provinceId,
        subscription: data.subscription ? 2 : 1, // Convert boolean to integer: true (public) = 2, false (private) = 1
      })
        .then(() => {
          setLoading(false);

          NotificationManager.notify({
            type: 'success',
            message: 'Comune creato',
          });

          onClose();
        })
        .catch(() => {
          setLoading(false);
        });
    },
    [cityCreate, onClose]
  );

  return (
    <Modal size="lg">
      <FormProvider {...useFormMethods}>
        <form onSubmit={handleSubmit(handleOnSubmit)}>
          <ModalHeader>Nuovo comune</ModalHeader>
          <ModalBody>
            <NewCityModalForms isLoading={isLoading} />
          </ModalBody>
          <ModalFooter>
            <Button
              variant="secondary"
              onClick={() => onClose()}
              disabled={isLoading}
            >
              Annulla
            </Button>
            <Button type="submit" variant="primary" disabled={isLoading}>
              Crea
            </Button>
          </ModalFooter>
        </form>
      </FormProvider>
    </Modal>
  );
};

export default NewCityModal;
